<template>
  <div class="container_wrapper">
    <left-menu title="测风数据" :show-menu="true" showFooter></left-menu>
    <main-content></main-content>
  </div>
</template>

<script>
import leftMenu from '../components/left-menu.vue';
import mainContent from './content.vue';
export default {
  computed: {},
  methods: {},
  components: {
    leftMenu,
    mainContent
  }
};
</script>

<style></style>
